import './bootstrap.js'
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import store from './store.js';
import routes from './routes';
import panelApi, { syncPanelAuthFromStorage } from './api/panel-axios';
import appConfig from './config.js';
import { isUnauthorized } from './api/http-status.js';
import { clearData, init as initOAuth, authorize, getPanelAccessToken } from './auth/id-auth.js';
import "./registerServiceWorker";
import Sidebar from './components/Sidebar.vue'
import Footer from './components/Footer.vue'
require('dayjs/locale/pl')
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pl';
import dayjs from "dayjs"
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import ThemeColor from './theme.js'
import Lang from 'vue-lang'
import VueMask from 'v-mask'

import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.use(VueMask);

import {
    Tooltip
} from "bootstrap";
window.onload = function () {
    ThemeColor.init();
}
var locales = {
    "en": require("./locale/en.json"),
    "pl": require("./locale/pl.json")
}
Vue.use(Lang, {
    lang: 'en',
    locales: locales
})
Vue.directive('tooltip', {
    inserted: function (el, bind) {
        new Tooltip(el, {
            trigger: 'hover',
            boundary: document.body
        })
    },
    update: function (el, bind) {
        setTimeout(function () {
            if (el.title) {
                el.setAttribute('data-bs-original-title', el.title);
            }
            Tooltip.getInstance(el).update();
        }, 250);
    }
})
dayjs.extend(customParseFormat)
Vue.use(Toast);
Vue.use(Vuex)
Vue.use(VueRouter)

Vue.prototype.$maskPhone = function (phone) {
    if (!phone) return '';
    const cleanPhone = phone.toString();
    if (cleanPhone.length < 5) return '***';
    return cleanPhone.substring(0, 3) + '***' + cleanPhone.substring(cleanPhone.length - 2);
};

Vue.prototype.$maskSms = function (body) {
    if (!body) return '';
    const strBody = body.toString();
    const half = Math.floor(strBody.length / 2);
    return strBody.substring(0, half) + '...';
};

Vue.prototype.$maskPassword = function (pwd) {
    return '********';
};

const router = new VueRouter({
    mode: 'history',
    routes
});

router.afterEach(to => document.title = (to.meta.title ? to.meta.title : 'SMS Magico'));

const app = new Vue({
    router,
    store,
    el: "#app",
    name: "VueApp",
    components: {
        Sidebar,
        'app-footer': Footer
    },
    data: function () {
        return {
            isLogin: false,
            initializing: true,
            configLoadAttempts: 0,
        }
    },
    computed: {
        isAdmin: function () {
            return ['owner', 'manager', 'admin', 'staff'].includes(this.$store.getters['app/role'])
        }
    },
    created: function () {
        this.initApp();
    },
    mounted: function () {
        console.log('app_mounted');
    },
    methods: {
        initApp: function () {
            const vm = this;
            vm.$store.dispatch('auth/loadFromStorage');
            syncPanelAuthFromStorage();
            initOAuth(function () {
                vm.$store.dispatch('auth/loadFromStorage');
                syncPanelAuthFromStorage();
                vm.loadPanelConfig();
            }, vm.$router, function () {
                vm.initializing = false;
            });
        },
        loadPanelConfig: function () {
            const vm = this;
            vm.configLoadAttempts += 1;

            panelApi.get(appConfig.panelApiPrefix + '/config').then(response => {
                vm.$store.commit('app/setRole', response.data.user.role);
                vm.$store.commit('app/setOptions', response.data.options);
                if (response.data.lang) {
                    vm.$setLang(response.data.lang);
                }
                vm.isLogin = true;
                vm.initializing = false;
            }).catch((error) => {
                const status = error?.response?.status;
                console.warn('Panel config failed', status, error?.response?.data || error);

                if (isUnauthorized(error) && getPanelAccessToken() && vm.configLoadAttempts < 2) {
                    syncPanelAuthFromStorage();
                    vm.loadPanelConfig();
                    return;
                }

                if (isUnauthorized(error)) {
                    vm.isLogin = false;
                    vm.initializing = false;
                    clearData();
                    authorize();
                    return;
                }

                vm.isLogin = true;
                vm.initializing = false;
            });
        },
        logout() {
            clearData();
            this.isLogin = false;
            const authUrl = appConfig.authUrl.replace(/\/$/, '');
            window.location.href = authUrl + '/logout';
        },
    },
});
